var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 44,
    viewBox: "0 0 32 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39968 2.38783C5.54432 3.74614 3.25697 6.06447 1.93718 8.93783C0.62555 11.5646 0.0656443 14.5029 0.319327 17.428C0.573011 20.3531 1.63041 23.1511 3.37468 25.5128L15.7872 43.3253L28.1872 25.5128C30.1943 22.8247 31.2696 19.5551 31.2497 16.2003C31.2497 5.25033 19.9997 -2.99967 8.39968 2.38783ZM15.9997 21.3878C14.8842 21.3903 13.793 21.0618 12.8643 20.4438C11.9355 19.8259 11.211 18.9463 10.7824 17.9164C10.3538 16.8865 10.2404 15.7526 10.4565 14.6582C10.6726 13.5638 11.2085 12.5581 11.9964 11.7685C12.7844 10.9788 13.7888 10.4406 14.8827 10.2221C15.9767 10.0035 17.1108 10.1145 18.1417 10.5408C19.1725 10.9671 20.0537 11.6897 20.6737 12.617C21.2937 13.5444 21.6247 14.6348 21.6247 15.7503C21.6247 17.2433 21.0324 18.6754 19.9779 19.7322C18.9234 20.7891 17.4927 21.3845 15.9997 21.3878Z",
    fill: "#4461F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/locationMarker.e63527d422c17fed1f3c40df7abcb63b.svg";
export { ForwardRef as ReactComponent };